import React, { Fragment } from 'react';
import { node } from 'prop-types';
import Head from 'next/head';

function AmpAccordion({ children }) {
  return (
    <Fragment>
      <Head>
        <script
          async
          custom-element="amp-accordion"
          key="amp-accordion"
          src="https://cdn.ampproject.org/v0/amp-accordion-0.1.js"
        />
      </Head>
      <amp-accordion disable-session-states="" animate="">
        <section>{children}</section>
      </amp-accordion>
    </Fragment>
  );
}

AmpAccordion.propTypes = {
  children: node.isRequired
};

export default AmpAccordion;
